import { render, staticRenderFns } from "./RelatoriosAutocomplete.vue?vue&type=template&id=8f7cfecc&scoped=true"
import script from "./RelatoriosAutocomplete.vue?vue&type=script&lang=js"
export * from "./RelatoriosAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7cfecc",
  null
  
)

export default component.exports